import config from './config.js'
import Firebase from 'firebase'


export default{
    constructDB(){
        const app = Firebase.initializeApp(config)
        let db = app.firestore()
        return db
    },
    async destroyedApp(){
        // console.log(Firebase.apps)
        if(Firebase.apps.length > 0){
            await Firebase.app().delete()
        }
        return 
    }
}